import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';

//#region UI configuration
const strings = {
    errorMessage: '404 - Page not found'
};
//#endregion

//#region Props & State
//#endregion

export class NotFoundPage extends React.Component {

    render() {
        return (
            <Grid container={true} justify="center">
                <Grid item={true}>
                    <Typography variant="headline">{strings.errorMessage}</Typography>
                </Grid>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/errors/NotFoundPage.tsx